export const STEPSCONFIG = {
	BASIC_INFO: "basicInfo",
	CURRENT_POSTING: "currentPosting",
	EMPLOYMENT_DETAILS: "employmentDetails",
	ATTACHEMENTS: "attachments",
};
